<template>
    <div class="default-home sms-page">
        <div class="sms-page__shell">
            <div class="sms-page__header">
                <div>
                    <span class="sms-page__eyebrow">Communication</span>
                    <h5 class="title sms-page__title">{{ $tl("labels.routes.sms") }}</h5>
                    <p class="sms-page__subtitle">Activez les SMS, suivez les crédits disponibles et commandez des packs adaptés à votre activité.</p>
                </div>
            </div>

            <div class="sms-page__card sms-page__stats">
                <strong>{{ $tl("infos.sms.stats.title") }}</strong>
                <div class="sms-page__stats-grid">
                    <div class="sms-page__stat">
                        <span>{{ $tl("infos.sms.stats.openingRate.title") }}</span>
                        <strong>{{ $t("infos.sms.stats.openingRate.value", { percentSms: 95, percentEmail: 20 }) }}</strong>
                    </div>
                    <div class="sms-page__stat">
                        <span>{{ $tl("infos.sms.stats.readTimeDelay.title") }}</span>
                        <strong>{{ $t("infos.sms.stats.readTimeDelay.value", { timeSms: 4, timeEmail: 90 }) }}</strong>
                    </div>
                    <div class="sms-page__stat">
                        <span>{{ $tl("infos.sms.stats.spam.title") }}</span>
                        <strong>{{ $t("infos.sms.stats.spam.value", { percentSms: 0, percentEmail: 80 }) }}</strong>
                    </div>
                </div>
            </div>

            <loader-component v-if="loadingSmsMode" />
            <div v-else>
                <template v-if="smsActivated">
                    <sms-pack></sms-pack>
                </template>
                <div v-else class="sms-page__card sms-page__activation">
                    <template v-if="isNoShow">
                        <p>
                            {{ $t("infos.sms.freeWhenEnabled", { nb: 100 }) }}<br />
                            <i class="text-muted">{{ $tl("infos.sms.configNotifs") }}</i>
                        </p>
                    </template>
                    <p v-else>
                        {{ $tl("infos.sms.configNotifs") }}
                    </p>
                    <button type="button" class="btn btn-sm btn-circle btn-success" :disabled="!isOwner" @click="activateSms">
                        {{ $tl("labels.form.sms.enable") }}
                    </button>
                    <span class="text-danger d-block mt-2" v-if="!isOwner">{{ $tl("labels.form.sms.notEnoughRights") }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoaderComponent from "../components/LoaderComponent.vue";
import SmsPack from "../components/sms/ListSmsPacks.vue";
import RolesEnum from "../mixins/enums/RolesEnum.js";

export default {
    name: "ListSmsPacks",
    data() {
        return {
            loadingSmsMode: true,
            smsActivated: null,
        };
    },
    mixins: [RolesEnum],
    computed: {
        role() {
            return this.$store.getters["users/role"];
        },
        isOwner() {
            return this.role === this.ROLE_OWNER.value;
        },
    },
    methods: {
        fetchData() {
            this.fetchIfSmsActivated();
        },
        fetchIfSmsActivated() {
            this.loadingSmsMode = true;

            this.httpGet("/api/sms/activation")
                .then((response) => {
                    if (response !== false) {
                        this.smsActivated = response.data.isActivated;
                    }
                })
                .finally(() => (this.loadingSmsMode = false));
        },
        activateSms() {
            this.loadingSmsMode = true;

            this.httpPost("/api/sms/activation", {}, { handleResolve: false }).then((response) => {
                if (response !== false) {
                    location.reload();
                } else {
                    this.loadingSmsMode = false;
                }
            });
        },
    },
    created() {
        this.fetchData();
    },
    components: {
        SmsPack,
        LoaderComponent,
    },
};
</script>

<style scoped>
.sms-page {
    min-height: calc(100vh - 72px);
    padding: 28px 18px 40px;
    background: linear-gradient(180deg, #f7fbfc 0%, #eef8fa 100%);
}

.sms-page__shell {
    width: 100%;
    max-width: 1080px;
    margin: 0 auto;
}

.sms-page__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
    margin-bottom: 18px;
}

.sms-page__eyebrow {
    display: inline-flex;
    margin-bottom: 8px;
    color: var(--main-color-light, #30a4b7);
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.sms-page__title {
    margin: 0;
    color: #142f3c;
    font-size: 1.45rem;
    font-weight: 700;
}

.sms-page__subtitle {
    max-width: 640px;
    margin: 8px 0 0;
    color: #6c7f88;
    line-height: 1.5;
}

.sms-page__card {
    margin-bottom: 18px;
    padding: 24px;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 18px 45px rgba(15, 58, 72, 0.07);
}

.sms-page__stats-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
    margin-top: 18px;
}

.sms-page__stat {
    padding: 16px;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 14px;
    background: linear-gradient(180deg, rgba(48, 164, 183, 0.08), rgba(255, 255, 255, 0.9));
}

.sms-page__stat span {
    display: block;
    margin-bottom: 6px;
    color: #6c7f88;
    font-size: 0.86rem;
}

.sms-page__stat strong {
    color: #173746;
}

.sms-page__activation {
    text-align: center;
}

@media (max-width: 767.98px) {
    .sms-page {
        padding: 20px 12px 32px;
    }

    .sms-page__header {
        align-items: flex-start;
        flex-direction: column;
    }

    .sms-page__stats-grid {
        grid-template-columns: 1fr;
    }
}
</style>
